// The two .sc-body columns (Scenes and Overview tabs): dragging the grip between them sets the left column's width.
import { trackDrag } from "./drag";

// a dragged left column stays between LEFT_MIN and what leaves the right column RIGHT_MIN
export const LEFT_MIN = 300,
  RIGHT_MIN = 480;

/**
 * Start dragging the grip (the mousedown event's target, a child of .sc-body).
 * @param onWidth called with the new left column width in px while dragging
 * @param onEnd called when the button is released
 * @returns a function that ends the drag early (e.g. on unmount)
 */
export function dragColumns(e, onWidth, onEnd) {
  e.preventDefault();
  const grip = e.currentTarget,
    body = grip.parentElement,
    x0 = e.clientX,
    g0 = grip.offsetLeft,
    max = body.clientWidth - 16 - RIGHT_MIN;
  // while the right column is at its max width the columns are centered, so the grip sits at
  // (free + left) / 2: solve for the left width that puts the grip under the mouse
  const free = body.clientWidth - 16 - parseFloat(getComputedStyle(body).getPropertyValue("--sc-rmax"));
  const leftAt = (g) => (g >= free ? g : 2 * g - free);
  return trackDrag((ev) => onWidth(Math.round(Math.max(LEFT_MIN, Math.min(max, leftAt(g0 + ev.clientX - x0))))), "col-resize", onEnd);
}
